import PropTypes from 'prop-types'
import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import DynamicImage from 'components/DynamicImage'

import laptop from './assets/rotated-macbook-bg.png'

import './FrameMacSide.scss'

/**
 * Component to print some images on the screen on the macbook's image
 *
 * @param {object} props - Properties of the component
 * @returns {function} function - FrameMacSide
 */
const FrameMacSide = props => {
  const { src, children, className } = props

  return (
    <div className={`frame-mac-side ${className}`}>
      <img className="frame-mac-side__laptop" src={laptop} />
      <div className="frame-mac-side__frame">
        <TransitionGroup component={null}>
          <CSSTransition
            timeout={{ enter: 400, exit: 700 }}
            key={src}
            classNames="frame-mac-side__image-"
          >
            {state => (
              <div className={`frame-mac-side__image ${state}`}>
                <DynamicImage
                  imageSizes={{ xs: 400, md: 500 }}
                  image={src}
                  alt=""
                />
              </div>
            )}
          </CSSTransition>
        </TransitionGroup>
      </div>
      {children}
    </div>
  )
}

FrameMacSide.propTypes = {
  /** Alternate text for image */
  alt: PropTypes.string.isRequired,

  /** Path to image to show it inside frame */
  src: PropTypes.string.isRequired,

  /** You can pass here some node to render it after frame */
  children: PropTypes.node,

  /** Class names for wrapper */
  className: PropTypes.string,
}

FrameMacSide.defaultProps = {
  className: '',
  children: null,
}

export default FrameMacSide
